import reducer from "./reducer";
export { default as AbsentCollaboratorsDialog } from "./components/index";
export { default as absentCollaboratorsDialogReducerName } from "./constants";
export default reducer;
